export const volumeIconSvg = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.91669 11.4584H8.75002L12.1528 14.3751V3.68066L8.75002 6.59733H2.91669V11.4584Z" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M4.86127 15.3469V11.458H6.80571V15.3469C6.80571 15.8838 6.37043 16.3191 5.83349 16.3191C5.29655 16.3191 4.86127 15.8838 4.86127 15.3469Z" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M12.1528 11.5281C12.4719 11.5281 12.788 11.4652 13.0829 11.3431C13.3778 11.2209 13.6457 11.0419 13.8714 10.8162C14.0971 10.5905 14.2762 10.3226 14.3983 10.0277C14.5204 9.73279 14.5833 9.41673 14.5833 9.09755C14.5833 8.77836 14.5204 8.4623 14.3983 8.16741C14.2762 7.87253 14.0971 7.60458 13.8714 7.37889C13.6457 7.15319 13.3778 6.97415 13.0829 6.85201C12.788 6.72986 12.4719 6.66699 12.1528 6.66699L12.1528 9.09755L12.1528 11.5281Z" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M16.25 9.16699H17.5" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M14.7664 5L15.6503 4.11612" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M14.7664 12.5L15.6503 13.3839" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`

const VolumeIcon = ({ size = 24, color = 'currentColor', ...props }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M2.91669 11.4584H8.75002L12.1528 14.3751V3.68066L8.75002 6.59733H2.91669V11.4584Z"
                stroke={color}
                strokeWidth="1.25"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M4.86127 15.3469V11.458H6.80571V15.3469C6.80571 15.8838 6.37043 16.3191 5.83349 16.3191C5.29655 16.3191 4.86127 15.8838 4.86127 15.3469Z"
                stroke={color}
                strokeWidth="1.25"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12.1528 11.5281C12.4719 11.5281 12.788 11.4652 13.0829 11.3431C13.3778 11.2209 13.6457 11.0419 13.8714 10.8162C14.0971 10.5905 14.2762 10.3226 14.3983 10.0277C14.5204 9.73279 14.5833 9.41673 14.5833 9.09755C14.5833 8.77836 14.5204 8.4623 14.3983 8.16741C14.2762 7.87253 14.0971 7.60458 13.8714 7.37889C13.6457 7.15319 13.3778 6.97415 13.0829 6.85201C12.788 6.72986 12.4719 6.66699 12.1528 6.66699L12.1528 9.09755L12.1528 11.5281Z"
                stroke={color}
                strokeWidth="1.25"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M16.25 9.16699H17.5"
                stroke={color}
                strokeWidth="1.25"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M14.7664 5L15.6503 4.11612"
                stroke={color}
                strokeWidth="1.25"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M14.7664 12.5L15.6503 13.3839"
                stroke={color}
                strokeWidth="1.25"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

export default VolumeIcon
